// Field help has its own conservative rich-text contract, independent of tours.
const allowedTags = new Set(['p', 'br', 'strong', 'b', 'em', 'i', 'u', 's', 'ul', 'ol', 'li', 'h2', 'h3', 'h4', 'blockquote', 'pre', 'code', 'a', 'table', 'thead', 'tbody', 'tfoot', 'tr', 'td', 'th', 'span', 'div', 'hr'])
const discardedTags = new Set(['script', 'style', 'iframe', 'object', 'embed', 'svg', 'math', 'template', 'noscript', 'textarea', 'title', 'xmp', 'plaintext'])
const voidTags = new Set(['br', 'hr'])

function escapeHtml(value) {
  return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')
}

function meaningfulText(value) {
  return value.replace(/[\s\u00a0\u200b-\u200d\ufeff]/g, '') !== ''
}

function safeHref(value) {
  const href = value.trim()
  if (!href || Array.from(href).some(character => character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127)) return ''
  try {
    const url = new URL(href, 'https://field-help.invalid/')
    return ['https:', 'http:', 'mailto:', 'tel:'].includes(url.protocol) ? href : ''
  } catch (error) {
    return ''
  }
}

export function sanitizeFieldHelpHtml(value) {
  if (typeof value !== 'string' || !value.trim() || typeof DOMParser === 'undefined') return ''
  const parsed = new DOMParser().parseFromString(value, 'text/html')
  function render(node) {
    if (node.nodeType === 3) return escapeHtml(node.textContent || '')
    if (node.nodeType !== 1) return ''
    const tag = node.tagName.toLowerCase()
    if (discardedTags.has(tag) || (node.namespaceURI && node.namespaceURI !== 'http://www.w3.org/1999/xhtml')) return ''
    const content = Array.from(node.childNodes).map(render).join('')
    if (!allowedTags.has(tag)) return content
    let attributes = ''
    if (tag === 'a') {
      const href = safeHref(node.getAttribute('href') || '')
      if (href) attributes = ` href="${escapeHtml(href)}" target="_blank" rel="noopener noreferrer"`
      const title = node.getAttribute('title')
      if (title) attributes += ` title="${escapeHtml(title)}"`
    }
    return `<${tag}${attributes}>${voidTags.has(tag) ? '' : content + `</${tag}>`}`
  }
  const html = Array.from(parsed.body.childNodes).map(render).join('')
  const text = new DOMParser().parseFromString(html, 'text/html').body.textContent || ''
  return meaningfulText(text) ? html : ''
}

export function normalizeFieldHelp(help) {
  const source = help && typeof help === 'object' && !Array.isArray(help) ? help : {}
  const description = sanitizeFieldHelpHtml(source.description)
  const instructions = sanitizeFieldHelpHtml(source.instructions)
  const example = typeof source.example === 'string' && meaningfulText(source.example) ? source.example.trim() : ''
  return { description, example, instructions, hasContent: Boolean(description || example || instructions) }
}
